import { useTranslation } from '@/i18n';
import { Radio, RadioProps } from '@moneyforward/ap-frontend-components';
import { RadioChangeEvent } from 'antd';
import classnames from 'classnames';
import { FC, memo, useCallback } from 'react';
import type { SelectedType } from '../../Drawer/OcrReflectionDrawer/hooks/useApplicationFormSelectionManager';
import styles from './OcrReflectionApplicationFormSwitcher.module.scss';

const cx = classnames.bind(styles);

export type Props = {
  onChange: (value: SelectedType) => void;
  value: SelectedType;
};

export const OcrReflectionApplicationFormSwitcher: FC<Props> = memo(
  ({ onChange, value }) => {
    const onChangeRadio = useCallback(
      (e: RadioChangeEvent) => {
        onChange(e.target.value);
      },
      [onChange]
    );
    const { t } = useTranslation();
    const options: RadioProps['options'] = [
      {
        testId: 'registered',
        id: 'registered',
        value: 'registered',
        label: t('invoice_reports.registered_payee'),
      },
      {
        testId: 'instant-payee',
        id: 'instant-payee',
        value: 'instant',
        label: t('invoice_reports.instant_payee'),
      },
    ];
    return (
      <div className={cx(styles['container'])}>
        <h2 className={cx(styles['title'])}>
          {t('invoice_reports.payee_type')}
        </h2>
        <Radio
          vertical={false}
          onChange={onChangeRadio}
          options={options}
          testId='registered-o-instant'
          value={value}
        />
      </div>
    );
  }
);
OcrReflectionApplicationFormSwitcher.displayName =
  'OcrReflectionApplicationFormSwitcher';
